var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.956 1.4286C13.5831 3.48228 11.5756 5.43725 9.73759 7.98791C8.92702 9.11291 8.02562 10.437 7.4364 11.6872C7.10002 12.3501 6.49365 13.3859 6.28693 14.3818C5.1563 13.33 3.94187 12.1361 2.6993 11.2009C1.81365 10.5346 -0.737289 11.8931 0.301086 12.6744C2.16212 14.0742 3.70984 15.8176 5.51996 17.2798C6.27709 17.8907 7.95502 16.5641 8.34934 16.0075C9.64365 14.1737 9.82055 11.9322 10.7639 9.93191C12.2041 6.87275 14.7585 4.35978 17.2804 2.17757C18.9513 0.61916 17.2256 0.331722 15.9586 1.4286",
    fill: "#008D40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0e3cfb039f5f1e19bb69138a910fce10.svg";
export { ForwardRef as ReactComponent };